import React, { useState } from "react"
import { Row } from "react-bootstrap"
import Training from "./Training"
import getServerURL from "../../../../functions/getServerURL"
import axios from "axios"


export default function TrainingListItem({ training, getTrainings, getTrainingMetadata }) {
  // STATE
  const [isExpanded, setIsExpanded] = useState(false)
  const [trainingDetails, setTrainingDetails] = useState(null)
  const [fetchingTrainingDetails, setFetchingTrainingDetails] = useState(false)

  const getTrainingDetails = () => {
    setFetchingTrainingDetails(true)
    axios.get(`${getServerURL()}trainings/${training.id}/get_training_details/`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
    }).then(response => {
      setTrainingDetails(response.data)
    }).catch(error => {
      console.log(error.response)
    }).finally(() => {
      setFetchingTrainingDetails(false)
    })
  }

  const handleExpand = () => {
    if (!isExpanded) {
      getTrainingDetails()
    } else {
      setTrainingDetails(null)
    }
    setIsExpanded(!isExpanded)
  }

  return (
    <React.Fragment>
      <tr onClick={ handleExpand } className={`qms-training-table-item ${ isExpanded && "active" }`}>
        <td> 
          <div><strong>{training.type}</strong></div>
        </td>
        <td>
          <div><strong>{training.number}</strong></div>
        </td>
        <td>
          <div><strong>{training.version}</strong></div>
        </td>
        <td>
          <div>{training.title}</div>
        </td>
        <td>
          <div>{ training.is_published ? "Published" : "Not Published"}</div>
        </td>
      </tr>
      { Boolean(isExpanded) &&
        <tr className="data-access-request-table-item-expanded">
          <td colSpan={4}>
            <Row style={{ margin: "0px" }}>
              { fetchingTrainingDetails ?
                <center>
                  <div id="not-found">
                    <img alt="loader" width={100} src={require("../../../../static/images/spinner.gif")}/>
                  </div>
                </center>
                :
                <div>
                  { trainingDetails ?
                    <Training
                      training={ trainingDetails }
                      getTrainingDetails={ getTrainingDetails }
                      getTrainings={ getTrainings }
                      getTrainingMetadata={ getTrainingMetadata }
                    />
                    :
                    "Could not get the training details"
                  }
                </div>
              }
            </Row>
          </td>
        </tr>
      }
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/TrainingListItem.js